import blockAnimation from "../pages/home/blockAnimation";
import bannerSlider from "../pages/home/bannerSlider";
// import frontSlider from "../pages/home/frontSlider";
import roomTour from "../pages/home/roomTour";
import GET_INSTAGRAM from "./instagram";
import Swiper from "swiper/bundle";

export default function HOME() {

  var swiperEvents = new Swiper(".events-swiper", {
    grabCursor: true,
    slidesPerView: "auto",
    spaceBetween: 36,
    // loop: true,
    pagination: {
      el: ".events-content__loader .loading-bar",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".events-header .swiper-button-next",
      prevEl: ".events-header .swiper-button-prev",
    },
  });

  var swiperTopics = new Swiper(".topics-swiper", {
    grabCursor: true,
    slidesPerView: "auto",
    spaceBetween: 36,
    // loop: true,
    pagination: {
      el: ".topics-content__loader .loading-bar",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".topics-header .btn-slider.next",
      prevEl: ".topics-header .btn-slider.pre",
    },
  });

  window.addEventListener('load',() => {
    swiperEvents.slideToLoop(0);
    swiperTopics.slideToLoop(0);
  });

  // Instagram
  $(() => new GET_INSTAGRAM);
    
  // Block animation
  blockAnimation();

  // Banner slide
  bannerSlider();
    
  // room tour
  roomTour();
}